<div mat-dialog-title>
  <mode-dialog-header>
    <h1 heading>
      Ask an Admin to connect a Database
    </h1>
  </mode-dialog-header>
</div>

<div mat-dialog-content>
  <capra-icon icon="illo-database" class="capra-db-icon"></capra-icon>
  <p>Only admins of this Workspace can connect data. Select an admin below and we'll let them know you've requested a new connection.</p>
  <form #form="ngForm">
    <div class="group">
      <label class="mode-label"
        for="admin"
      >
        Admins
      </label>
      <mat-select [value]="defaultAdmin$ | async"
        id="admin"
      >
        <mat-option
          *ngFor="let admin of data.admins$ | async"
          [value]="admin.id"
        >
          {{ admin.name }}
        </mat-option>
      </mat-select>
    </div>
    <div class="group">
      <label class="mode-label"
        for="message"
      >
        Message
      </label>
      <textarea id="message"
        class="mode-textarea"
        name="message"
        [ngModel]="defaultMessage"
      ></textarea>
    </div>
  </form>
</div>

<div mat-dialog-actions class="actions">
  <capra-button
    text="Cancel"
    variant="secondary"
    color="neutral"
    (clicked)="dialogRef.close()"
  ></capra-button>
  <capra-button
    type="submit"
    text="Send email"
    (clicked)="onSendEmail(form.value)"
  ></capra-button>
</div>
